import React from 'react'
import {Icon} from '@chakra-ui/react'

const ImageIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M7.5 9C8.32843 9 9 8.32843 9 7.5C9 6.67157 8.32843 6 7.5 6C6.67157 6 6 6.67157 6 7.5C6 8.32843 6.67157 9 7.5 9Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 2H5C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2ZM4 19V18.4142L7.54773 14.8665C7.88479 14.5294 8.41291 14.4771 8.80954 14.7415L10.4453 15.8321C10.8419 16.0965 11.37 16.0442 11.7071 15.7071L15.2929 12.1213C15.6834 11.7308 16.3166 11.7308 16.7071 12.1213L20 15.4142V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19ZM18.1213 10.7071L20 12.5858V5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V15.5858L6.13352 13.4523C7.14471 12.4411 8.72907 12.2842 9.91894 13.0774L10.8726 13.7132L13.8787 10.7071C15.0503 9.53553 16.9497 9.53553 18.1213 10.7071Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ImageIcon
